<template lang="html">
    <div class="w-100">
        <!-- area-->
        <div class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flex">
                <div class="d-flex flex-column">
                    <label>Extras:</label>
                    <i class="ico ico-alert color-6 mr-0 mt-1 fs-super text-center"
                        v-tooltip="'Pax without transport'"
                        v-if="transportDiference"></i>
                </div>
                
                <div class="d-flex">
                    <div class="bold fs-smaller d-flex flex-column px-2 extra-name-container">
                        <div v-for="bookingComponent in bookingComponents" class="mb-1">
                            <div v-if="bookingComponent.quantity > 0 && (bookingComponent.quantityToAdd === 0 || bookingComponent.quantityToAdd === null || bookingComponent.quantityToAdd === undefined)">
                                <span class="text-break">
                                    {{bookingComponent.quantity}} x {{bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name}}
                                </span>
                            </div>
                            
                            <div v-else-if="bookingComponent.id && bookingComponent.quantity > 0 && bookingComponent.quantityToAdd > 0" class="d-flex flex-column">
                                <span class="text-break">
                                    {{bookingComponent.quantity - bookingComponent.quantityToAdd}} x {{bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name}}
                                </span>
        
                                <span class="dark text-break">
                                    {{bookingComponent.quantityToAdd}} x {{bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name}}
                                </span>
                            </div>

                            <div v-else-if="!bookingComponent.id && bookingComponent.quantityToAdd > 0" class="d-flex flex-column">
                                <span class="dark text-break">
                                    {{bookingComponent.quantityToAdd}} x {{bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name}}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end">
                        <button :disabled="disabled || isReservationReadOnly && reservation.status != -5" class="btn secondary " @click="toggleViewExtas">Edit</button>
                        <button :disabled="disabled || isReservationReadOnly && reservation.status != -5" class="btn secondary  ml-2 text-nowrap" @click="toggleAddExtas">+ Add Extras</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- area-->
        <div class="">
            <!-- form row -->
            <div class="d-flex justify-content-between align-items-center">
                <label class="d-flex flexGrow1">Voucher code:</label>
                <input :disabled="disabled || isReservationReadOnly && reservation.status != -5" type="text" class="w-100 px-2 py-1 text-center bg-lighter" v-model="reservation.bookingOperatorCode" style="width: 200px !important;">
            </div>
        </div>

        <!-- area-->
        <div v-if="reservation.customer.bookingQuestion" class="border-bottom-medium pb-2 mb-2">
            <!-- form row -->
            <div class="d-flexjustify-content-between align-items-center">
                <label class="d-flex  w-100 flexGrow1">{{reservation.customer.bookingQuestion}}</label>
            </div>

            <div class="dark">
                <div v-if="reservation.customer.bookingAnswer">{{reservation.customer.bookingAnswer}}</div>
                <div v-else>No answer</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    mixins: [
        reservationsMixin,
    ],
    props: {
        reservation: {
            type: Object
        },
    },
    computed: {
        ...mapGetters([
            'getIsSavingReservation'
        ]),
        bookingComponents() {
            const grouped = [];

            this.reservation.bookingComponents.forEach(item => {
                const existing = grouped.find(groupedItem => 
                    groupedItem.component.id === item.component.id &&
                    groupedItem.componentPrice.id === item.componentPrice.id
                );

                if (existing) {
                    existing.quantity += item.quantity;
                    existing.quantityToAdd = (existing.quantityToAdd || 0) + (item.quantityToAdd || 0);
                } else {
                    grouped.push({
                        ...item,
                        quantity: item.quantity,
                        quantityToAdd: item.quantityToAdd || 0
                    });
                }
            });

            return grouped;
        },
        disabled() {
            return this.getIsSavingReservation;
        },
        transport() {
            return this.reservation.transport;
        },
        transportDiference() {
            const totalPax = this.reservation.bookingGenderPrices.reduce((acc, comp) => acc + comp.quantityToBook, 0);
            const totalTransport = this.reservation.bookingComponents.reduce((acc, comp) => acc + (comp.component.componentType === 1 ? comp.quantity : 0), 0);

            return totalTransport > 0 && totalPax !== totalTransport;
        }
    },
    methods:{
        toggleEditExtas() {
            this.eventHub.$emit('editReservation_toggleEditExtas');
        },
        toggleViewExtas() {
            this.eventHub.$emit('editReservation_toggleViewExtas');
        },
        toggleAddExtas() {
            this.eventHub.$emit('editReservation_toggleAddExtras');
        }
    }
}
</script>

<style lang="scss" scoped>
    .extra-name-container {
        width: 11.5rem;
    }
</style>



// WEBPACK FOOTER //
// reservationOtherExtras.vue?b4caf794